import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const CommentsSection = ({
  comments,
  newComment,
  setNewComment,
  isLoadingComments,
  postingComment,
  commentError,
  handleCommentSubmit,
  user
}) => {
  return (
    <div className="chapter-comments-section">
      <h3 style={{ marginBottom: 16 }}>Comments ({comments.length})</h3>
      
      <form onSubmit={handleCommentSubmit} className="comment-form">
        <input
          type="text"
          placeholder={user ? 'Add a comment (Markdown supported)...' : 'Login to comment'}
          className="comment-input"
          value={newComment}
          onChange={e => setNewComment(e.target.value)}
          disabled={!user || postingComment}
        />
        <button 
          type="submit" 
          className="post-comment-button"
          disabled={!user || postingComment || !newComment.trim()}
        >
          Post
        </button>
      </form>
      
      {commentError && <div style={{ color: 'red', marginBottom: 10 }}>{commentError}</div>}
      
      {isLoadingComments ? (
        <div>Loading comments...</div>
      ) : (
        <div className="comments-list">
          {comments.map(comment => (
            <div key={comment.id} className="comment-item">
              <img 
                src={comment.profile_picture || 'https://placehold.co/40x40/16a085/ffffff?text=U'} 
                alt={comment.name} 
                className="comment-avatar"
              />
              <div className="comment-content">
                <div className="comment-author">{comment.name}</div>
                <div className="comment-date">
                  {comment.created_at ? new Date(comment.created_at).toLocaleString() : ''}
                </div>
                <div className="comment-text">
                  <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {comment.comment_text || ''}
                  </ReactMarkdown>
                </div>
              </div>
            </div>
          ))}
          {comments.length === 0 && (
            <div style={{ color: '#888', fontStyle: 'italic' }}>
              No comments yet. Be the first to comment!
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CommentsSection; 